import api from '@/services/api'

const RESOURCE_URI = '/rent'

const fetchRents = () => api.get(RESOURCE_URI)
const fetchRentById = (id) => api.get(`${RESOURCE_URI}/${id}`)
const fetchRentSignature = (id) => api.get(`${RESOURCE_URI}/${id}/signature`)
const createRent = (rent) => api.post(RESOURCE_URI, rent)
const updateRent = ({
  id,
  toyId,
  periodId,
  customerId,
  userId,
  storeId,
  notes,
  status
}) =>
  api.put(`${RESOURCE_URI}/${id}`, {
    id,
    toyId,
    periodId,
    customerId,
    userId,
    storeId,
    notes,
    status
  })
const removeRent = (id) => api.delete(`${RESOURCE_URI}/${id}`)

const startRent = ({
  toyId,
  periodId,
  storeId,
  customer,
  commissionUserStoreId,
  signature
}) =>
  api.post(`${RESOURCE_URI}/start`, {
    toyId,
    periodId,
    storeId,
    customer,
    ...(commissionUserStoreId ? { commissionUserStoreId } : {}),
    ...(signature ? { signature } : {})
  })

const duplicateRent = ({
  sourceRentId,
  toyId,
  periodId,
  commissionUserStoreId
}) =>
  api.post(`${RESOURCE_URI}/${sourceRentId}/duplicate`, {
    toyId,
    periodId,
    ...(commissionUserStoreId ? { commissionUserStoreId } : {})
  })

const pauseRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/pause`)

const resumeRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/resume`)

const closeRent = async ({
  id,
  checkoutId,
  payments,
  status,
  loyaltyDiscount
}) => {
  if (!status || status !== 'paused') {
    const pauseResponse = await pauseRent({ id })
    if (pauseResponse.status !== 'paused')
      throw new Error('Erro ao pausar o aluguel.')
  }

  return api.post(`${RESOURCE_URI}/${id}/close`, {
    checkoutId,
    payments,
    ...(loyaltyDiscount ? { loyaltyDiscount } : {})
  })
}

const transferRent = ({ id, toyId }) =>
  api.post(`${RESOURCE_URI}/${id}/transfer`, { toyId })

const cancelRent = async ({ id, reason }) => {
  //Versão 2110-3.1, adicionado funcionalidade de pausar alugueis antes de cancelar (evitando informações de tempos incorretas para futuras recuperações de alugueis!)
  const cancelResponse = await api.post(`${RESOURCE_URI}/${id}/cancel`, {
    reason
  })
  return cancelResponse
}
const calculateRentAmount = async ({ rent, elapsedTime, hasProducts }) => {
  try {
    const response = await api.post(`${RESOURCE_URI}/calculateRentAmount`, {
      rent,
      elapsedTime,
      hasProducts
    })
    return response
  } catch (error) {
    console.error('Erro ao calcular o valor do aluguel:', error)
    throw error
  }
}
const addExtraTime = ({ id, time, reason }) =>
  api.post(`${RESOURCE_URI}/${id}/extra-time`, { time, reason })

//editar um extra já existente
const updateExtraTime = ({ rentId, extraId, minutes, reason }) =>
  api.put(`${RESOURCE_URI}/${rentId}/extra-time/${extraId}`, {
    minutes,
    // só envia reason se vier definida (mantém contrato “opcional”)
    ...(typeof reason === 'string' ? { reason } : {})
  })

const removeExtraTime = ({ rentId, extraId }) =>
  api.delete(`${RESOURCE_URI}/${rentId}/extra-time/${extraId}`)

const reopenLastRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/reopen`)

const changePeriod = ({ id, periodId }) =>
  api.post(`${RESOURCE_URI}/${id}/change-period`, { periodId })

const addProduct = ({ id, productId, quantity }) =>
  api.post(`${RESOURCE_URI}/${id}/product`, { productId, quantity })

const removeProduct = ({ id, productId }) =>
  api.delete(`${RESOURCE_URI}/${id}/product/${productId}`)

const rescueRent = ({ id, documentPhoto }) => {
  const formData = new FormData()
  formData.append('documentPhoto', documentPhoto)
  return api.post(`${RESOURCE_URI}/${id}/rescue`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export default {
  calculateRentAmount,
  fetchRents,
  fetchRentById,
  fetchRentSignature,
  createRent,
  updateRent,
  removeRent,
  startRent,
  duplicateRent,
  pauseRent,
  resumeRent,
  closeRent,
  transferRent,
  cancelRent,
  addExtraTime,
  updateExtraTime,
  reopenLastRent,
  rescueRent,
  changePeriod,
  addProduct,
  removeProduct,
  removeExtraTime
}
